import { useMutation } from '@tanstack/react-query';
import { CouponApiV2 } from '../../../lib/api/coupon/CouponApiV2';
import toastMsg from '../../../lib/toastMsg';
import couponToastMsg from '../../../constants/service/toastMsg/couponToastMsg';
import { reDirectPage, setDetailPageUrl } from '../../../lib/common';
import { COUPON_DETAIL_URL_PATH } from '../../../constants/service/common/urlConstants';

export const useCreateCouponMutation = () => {
  return useMutation({
    mutationFn: (data: Record<string, unknown>) => CouponApiV2.insertCoupon(data),
    onSuccess: (result) => {
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(couponToastMsg.INSERT_COUPON_REQUEST_SUCCESS);
        reDirectPage({ path: setDetailPageUrl(COUPON_DETAIL_URL_PATH, result.data.couponId) });
      }
    },
    onError: (error: Error) => {
      toastMsg.error(couponToastMsg.INSERT_COUPON_REQUEST_ERROR, error);
    },
  });
};
